import { render, staticRenderFns } from "./CoursewareFileChooser.vue?vue&type=template&id=62569058&"
import script from "./CoursewareFileChooser.vue?vue&type=script&lang=js&"
export * from "./CoursewareFileChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports